/*
 * @Author: wsx
 * @Date: 2022-01-20 11:25:25
 * @LastEditTime: 2022-02-11 17:18:52
 * @LastEditors: Please set LastEditors
 * @Description:菜单接口
 */
import request from "@/utils/request.js";
// 获取菜单列表
export const getMenuList = data => {
  return request({
    url: "/api/hz-smart-community/sys/menu/list",
    params: data || {}
  });
};
// 添加菜单
export const addMenu = data => {
  return request({
    url: '/api/hz-smart-community/sys/menu/save',
    data: data || {},
    method: "POST"
  });
};
// 修改菜单
export const addUpdateMenu = data => {
  return request({
    url: '/api/hz-smart-community/sys/menu/update',
    data: data || {},
    method: "POST"
  });
};
// 删除菜单
export const delMenu = menuId => {
  return request({
    url: '/api/hz-smart-community/sys/menu/delete/' + menuId,
    method: "POST"
  });
};